<template>
  <div class="kt-portlet kt-portlet--mobile">
    <div class="kt-portlet__head">
      <div class="kt-portlet__head-label">
        <h3 class="kt-portlet__head-title">BI SnapData — Monitoring</h3>
      </div>
      <div class="kt-portlet__head-toolbar">
        <router-link to="/BudgetPlan/Monitoring" class="btn btn-secondary btn-sm">
          <i class="fas fa-arrow-left"></i> กลับ
        </router-link>
      </div>
    </div>
    <div class="kt-portlet__body">
      <!-- Filter -->
      <div class="row mb-3">
        <div class="col-xl-3">
          <label>MonthPeriod (yyyyMM):</label>
          <input
            type="text"
            class="form-control"
            placeholder="เช่น 202604"
            maxlength="6"
            v-model="filterMonthPeriod"
          />
        </div>
        <div class="col-xl-3">
          <label>สถานะ:</label>
          <select class="form-control" v-model="filterStatus">
            <option value="">ทั้งหมด</option>
            <option value="RUNNING">RUNNING</option>
            <option value="SUCCESS">SUCCESS</option>
            <option value="FAILED">FAILED</option>
          </select>
        </div>
        <div class="col-xl-6 d-flex align-items-end">
          <button class="btn btn-primary mr-2" @click="loadLogs" :disabled="isLoading">
            <i class="fas fa-search"></i> {{ isLoading ? 'กำลังโหลด...' : 'ค้นหา' }}
          </button>
          <button class="btn btn-warning mr-2" @click="sendNotifyEmail" :disabled="isSendingNotify">
            <i class="fas fa-envelope"></i> {{ isSendingNotify ? 'กำลังส่ง...' : 'Send Notify Email' }}
          </button>
        </div>
      </div>

      <!-- Notify Result -->
      <div v-if="notifyResult" class="alert" :class="notifyAlertClass">
        <strong>{{ notifyResult.message || notifyResult.Message }}</strong>
        <div v-if="notifyResult.notificationSent || notifyResult.NotificationSent" class="mt-2">
          <small>
            BatchId: {{ notifyResult.batchId || notifyResult.BatchId }} |
            MonthPeriod: {{ notifyResult.monthPeriod || notifyResult.MonthPeriod }} |
            FAILED: {{ notifyResult.failedCount || notifyResult.FailedCount }} / {{ notifyResult.totalSources || notifyResult.TotalSources }} sources |
            Recipients: {{ (notifyResult.recipients || notifyResult.Recipients || []).join(', ') }}
          </small>
        </div>
      </div>

      <!-- Table -->
      <div class="table-responsive">
        <table class="table table-sm table-striped table-bordered">
          <thead>
            <tr>
              <th class="text-center">#</th>
              <th class="text-center">LogId</th>
              <th class="text-center">MonthPeriod</th>
              <th>SourceName</th>
              <th class="text-center">StartTime</th>
              <th class="text-center">EndTime</th>
              <th class="text-center">Duration (ms)</th>
              <th class="text-center">RowCount</th>
              <th class="text-center">สถานะ</th>
              <th>ErrorMessage</th>
              <th>BatchId</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="logs.length === 0">
              <td colspan="11" class="text-center text-muted">ไม่พบข้อมูล</td>
            </tr>
            <tr v-for="(log, index) in logs" :key="log.logId">
              <td class="text-center">{{ index + 1 }}</td>
              <td class="text-center">{{ log.logId }}</td>
              <td class="text-center">{{ log.monthPeriod }}</td>
              <td>{{ log.sourceName }}</td>
              <td class="text-center">{{ formatDateTime(log.startTime) }}</td>
              <td class="text-center">{{ formatDateTime(log.endTime) }}</td>
              <td class="text-center">{{ log.durationMs != null ? log.durationMs.toLocaleString() : '-' }}</td>
              <td class="text-center">{{ log.rowCountSnap != null ? log.rowCountSnap.toLocaleString() : '-' }}</td>
              <td class="text-center">
                <span class="badge"
                  :class="{
                    'badge-warning': log.status === 'RUNNING',
                    'badge-success': log.status === 'SUCCESS',
                    'badge-danger': log.status === 'FAILED'
                  }">
                  {{ log.status }}
                </span>
              </td>
              <td><small class="text-danger">{{ log.errorMessage }}</small></td>
              <td><small>{{ log.batchId }}</small></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      filterMonthPeriod: "",
      filterStatus: "",
      logs: [],
      isLoading: false,
      isSendingNotify: false,
      notifyResult: null,
    };
  },
  computed: {
    notifyAlertClass() {
      if (!this.notifyResult) return "";
      var level = this.notifyResult.level || this.notifyResult.Level;
      if (level === "ERROR") return "alert-danger";
      if (level === "WARN") return "alert-warning";
      var sent = this.notifyResult.notificationSent || this.notifyResult.NotificationSent;
      return sent ? "alert-success" : "alert-info";
    },
  },
  mounted() {
    this.loadLogs();
  },
  methods: {
    loadLogs() {
      var self = this;
      var params = {};
      if (self.filterMonthPeriod) params.monthPeriod = self.filterMonthPeriod;
      if (self.filterStatus) params.status = self.filterStatus;

      self.isLoading = true;
      axios
        .get("/Api/BISnapData/Logs", { params })
        .then(function (response) {
          self.logs = response.data;
        })
        .catch(function (error) {
          console.error("Failed to load BI SnapData logs:", error);
        })
        .finally(function () {
          self.isLoading = false;
        });
    },
    sendNotifyEmail() {
      var self = this;
      self.isSendingNotify = true;
      self.notifyResult = null;

      axios
        .get("/Api/Monitor/bi_snapdata_notify")
        .then(function (response) {
          self.notifyResult = response.data;
        })
        .catch(function (error) {
          var data = (error.response && error.response.data) || {};
          self.notifyResult = {
            level: "ERROR",
            message: "เกิดข้อผิดพลาด: " + (data.message || data.Message || error.message),
            notificationSent: false,
          };
        })
        .finally(function () {
          self.isSendingNotify = false;
        });
    },
    formatDateTime(dateStr) {
      if (!dateStr) return "-";
      var d = new Date(dateStr);
      return d.toLocaleDateString("th-TH") + " " + d.toLocaleTimeString("th-TH");
    },
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/BudgetPlan/BudgetPlanMonitoringBiSnapData.vue